<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Remerciements</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-weight: bold; font-size: 1.00em;">MERCI</span> à Poppy Dennison de m’avoir convaincue et d’avoir été aussi enchantée que je l’étais de revisiter mon ancienne bibliothèque de collections de romances des années quatre-vingt, qui m’ont servi d’inspiration pour ce roman. Merci aussi à la Brooklyn Public Library d’avoir autant de Collection Azur dans son catalogue. Et un remerciement particulier à Damon Suede, qui m’a aidée pour le titre avant même que ce livre n’ait d’intrigue.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?794704d4